import { useEffect, useState } from 'react';
import { getOrganization } from '../../services/apiClient';
import type { Organization } from '../../types';
import styles from './AboutPage.module.css';

export function AboutPage() {
  const [org, setOrg] = useState<Organization | null>(null);

  useEffect(() => {
    getOrganization().then((r) => r.data && setOrg(r.data));
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className="container">
          <h1 className={styles.title}>About Us</h1>
        </div>
      </div>
      <div className="container">
        <div className={styles.body}>
          {org ? (
            <>
              <h2 className={styles.orgName}>{org.name}</h2>
              <p className={styles.description}>{org.public_description}</p>
              <div className={styles.contact}>
                {org.address && <p>{org.address}</p>}
                {org.contact_email && (
                  <p><a href={`mailto:${org.contact_email}`}>{org.contact_email}</a></p>
                )}
                {org.phone && (
                  <p><a href={`tel:${org.phone}`}>{org.phone}</a></p>
                )}
              </div>
            </>
          ) : (
            <p>Loading…</p>
          )}
        </div>
      </div>
    </div>
  );
}
